// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__A1qNp","content":"Layout_content__CTp00"};